import { render } from "./ProductIcon.vue?vue&type=template&id=4c542560"
import script from "./ProductIcon.vue?vue&type=script&lang=js"
export * from "./ProductIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__